function initCYCCarousel(parentSelector) {
  function initProductCarousel() {
    $(parentSelector + " .cyc-product-carousel").on("init", (function(event, slick) {
      renderNavigator(slick.currentSlide, slick.slideCount)
    })),
    $(parentSelector + " .cyc-product-carousel").slick({
      centerMode: !1,
      slidesToShow: 1,
      infinite: false,
      dots: !1,
      arrows: !0,
      prevArrow: '<div class="fa fa-chevron-left cyc-navigation-arrow"></div>',
      nextArrow: '<div class="fa fa-chevron-right cyc-navigation-arrow"></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {}
        }
      ]
    }),

// $(parentSelector + " .cyc-product-carousel").on('afterChange', function(event, slick, currentSlide, nextSlide) {
// if ((slick.slideCount - 1) == currentSlide) {
// setTimeout(function() {
// slick.goTo(0);
// }, slick.getOption('autoplaySpeed'));
// }
// }),
    $(parentSelector + " .cyc-product-carousel").on("swipe", (function(event, slick, direction) {
      renderNavigator(slick.currentSlide, slick.slideCount)
    })),
    $(parentSelector + " .cyc-product-carousel").on("setPosition", (function(event, slick, direction) {
      renderNavigator(slick.currentSlide, slick.slideCount)
    })),
    addOnClickEventCarouselImage(),
    window.addEventListener("hashchange", closeModal, !1)
  }
  function renderNavigator(currentIndex, totalElements) {
    let html = "";
    if (1 == totalElements) return html;
    


    for (var i = 0; i < totalElements; i++) 
      html = i == currentIndex
        ? html + '<div class="cyc-product-carousel-dot fas fa-circle" data-index="' + i + '"></div>'
        : html + '<div class="cyc-product-carousel-dot far fa-circle" data-index="' + i + '"></div>';
    


    $(parentSelector + " .cyc-product-carousel-navigator").html(html),
    addNavigatorClickEvent()
  }
  function addNavigatorClickEvent() {
    $(parentSelector + " .cyc-product-carousel-dot").each((function() {
      var index = $(this).attr("data-index");
      $(this).click((function() {
        $(parentSelector + " .cyc-product-carousel").slick("slickGoTo", parseInt(index))
      }))
    }))
  }
  function addOnClickEventCarouselImage() {
    $(parentSelector + " .cyc-carousel-image-container").each((function(e) {
      var index = $(this).attr("data-index"),
        initialPosition = null;
      $(this).mousedown((function(e) {
        initialPosition = {
          x: e.pageX,
          y: e.pageY
        }
      })),
      $(this).mouseup((function(e) {
        var finalPosition = {
          x: e.pageX,
          y: e.pageY
        };
        initialPosition && finalPosition && initialPosition.x == finalPosition.x && initialPosition.y == finalPosition.y && openModal(index)
      }))
    }))
  }
  function initModalCarousels() {
    $(parentSelector + " .cyc-product-modal-carousel").slick({
      centerMode: !1,
      slidesToScroll: 1,
      slidesToShow: 1,
      infinite: !0,
      dots: !1,
      arrows: !1,
      fade: !1
    }),
    $(parentSelector + " .cyc-product-modal-carousel-navigator").on("init", (function(event, slick) {
      $(parentSelector + " .cyc-product-modal-carousel-navigator .slick-slide.slick-current").addClass("is-active")
    })).slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      dots: !1,
      arrows: !1,
      focusOnSelect: !1,
      infinite: !1
    }),
    $(parentSelector + " .cyc-product-modal-carousel").on("afterChange", (function(event, slick, currentSlide) {
      $(parentSelector + " .cyc-product-modal-carousel-navigator").slick("slickGoTo", currentSlide);
      var currrentNavSlideElem = parentSelector + ' .cyc-product-modal-carousel-navigator .slick-slide[data-slick-index="' + currentSlide + '"]';
      $(parentSelector + " .cyc-product-modal-carousel-navigator .slick-slide.is-active").removeClass("is-active"),
      $(currrentNavSlideElem).addClass("is-active")
    })),
    $(parentSelector + " .cyc-product-modal-carousel-navigator").on("click", ".slick-slide", (function(event) {
      event.preventDefault();
      var goToSingleSlide = $(this).data("slick-index");
      $(parentSelector + " .cyc-product-modal-carousel").slick("slickGoTo", goToSingleSlide)
    }))
  }
  function initDeskptopCarouselNavigator() {
    $(parentSelector + " .cyc-product-carousel-navigator-desktop").on("init", (function(event, slick) {
      $(parentSelector + " .cyc-product-carousel-navigator-desktop .slick-slide.slick-current").addClass("is-active")
    })).slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      dots: !1,
      arrows: !1,
      focusOnSelect: !1,
      infinite: !1
    }),
    $(parentSelector + " .cyc-product-carousel").on("afterChange", (function(event, slick, currentSlide) {
      $(parentSelector + " .cyc-product-carousel-navigator-desktop").slick("slickGoTo", currentSlide);
      var currrentNavSlideElem = parentSelector + ' .cyc-product-carousel-navigator-desktop .slick-slide[data-slick-index="' + currentSlide + '"]';
      $(parentSelector + " .cyc-product-carousel-navigator-desktop .slick-slide.is-active").removeClass("is-active"),
      $(currrentNavSlideElem).addClass("is-active")
    })),
    $(parentSelector + " .cyc-product-carousel-navigator-desktop").on("click", ".slick-slide", (function(event) {
      event.preventDefault();
      var goToSingleSlide = $(this).data("slick-index");
      $(parentSelector + " .cyc-product-carousel").slick("slickGoTo", goToSingleSlide)
    }))
  }
  function addOnClickEventBackButton() {
    $(parentSelector + " .cyc-product-modal-button").click((function() {
      closeModal()
    })),
    $(parentSelector + " .cyc-product-modal-button-right").click((function() {
      closeModal()
    }))
  }
  function setProductModalElementsStyles(height) {
    $(parentSelector + " .cyc-product-modal-carousel").css("height", .9 * height + "px"),
    $(parentSelector + " .cyc-product-modal-image-container").css("height", .9 * height + "px"),
    $(parentSelector + " .cyc-product-modal-image").css("max-height", .85 * height + "px"),
    $(parentSelector + " .cyc-product-modal-carousel-image-container").css("height", .1 * height + "px"),
    $(parentSelector + " .cyc-product-modal-carousel-image").css("max-height", .1 * height - 4 + "px"),
    $("html").css("max-height", height + "px")
  }
  function openModal(index) {
    $(parentSelector + " .cyc-product-modal").css("visibility", "visible"),
    $(parentSelector + " .cyc-product-modal-button").css("display", "inline-block"),
    $(parentSelector + " .cyc-product-modal-carousel").slick("slickGoTo", index, !0),
    $("#___ratingbadge_0").css("display", "none"),
    $("body").css("overflow-y", "hidden"),
    $("body").addClass("cyc-lock-screen"),
    window.addEventListener("resize", (function() {
      setProductModalElementsStyles($(window).height())
    })),
    location.hash = "cyc-modal"
  }
  function closeModal(hashchangeEvent) {
    hashchangeEvent && hashchangeEvent.newURL.indexOf("cyc-modal") > -1 || ($(parentSelector + " .cyc-product-modal").css("visibility", "hidden"), $(parentSelector + " .cyc-product-modal-button").css("display", "none"), $("#___ratingbadge_0").css("display", "inline-block"), $("body").css("overflow-y", "auto"), $("body").removeClass("cyc-lock-screen"), window.location.hash.indexOf("cyc-modal") > -1 && window.history.back())
  }
  console.log("initializing carousel", parentSelector),
  parentSelector = parentSelector || "",
  setProductModalElementsStyles($(window.top).height()),
  initProductCarousel(),
  initModalCarousels(),
  addOnClickEventBackButton(),
  initDeskptopCarouselNavigator()
}
$((function() {
  0 === $(".quick_shop.action_button").length
    ? setTimeout((function() {
      initCYCCarousel()
    }), 10)
    : $(".quick_shop.action_button").each((function() {
      $(this).on("click", (function() {
        setTimeout((function() {
          initCYCCarousel(".fancybox-overlay")
        }), 10)
      }))
    }))
}));